import { defineMessages } from 'react-intl';

export default defineMessages({
  withLeavePageConfirmationUnsavedChangesWarning: {
    id: 'app.utils.hocs.withLeavePageConfirmation.unsavedChangesWarning',
    defaultMessage: 'Changes that you made may not be saved.',
  },
});
